<template>
  <table class="table">
    <thead>
      <tr>
        <th v-if="showOverflowMenu"></th>
        <th></th>
        <th>{{ lang.get('rounds.form.starts.label') }}</th>
        <th>{{ lang.get('rounds.form.ends.label') }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="round in rounds" :key="'round-' + round.id">
        <td v-if="showOverflowMenu">
          <round-overflow-menu
            v-if="!round.createdAt"
            :round="round"
            :labels="{
              edit: lang.get('buttons.edit'),
              delete: lang.get('buttons.delete')
            }"
            :show-edit-option="!configuredRound"
            @delete="onDelete"
            @edit="onEdit"
          />
        </td>
        <td>
          <div class="checkbox styled">
            <input
              :id="`round-${round.id}`"
              :name="`round[${round.id}]`"
              :value="round.id"
              :checked="round.selected"
              type="checkbox"
              @change="onChange"
            />
            <label :for="`round-${round.id}`">
              {{ round.name }}
            </label>
          </div>
        </td>
        <td>
          <date-timezone :date="round.startsAt" :timezone="round.startsTz" />
        </td>
        <td>
          <date-timezone :date="round.endsAt" :timezone="round.endsTz" />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import DateTimezone from '@/lib/components/Shared/DateTimezone';
import Icon from '@/lib/components/Shared/Icon';
import RoundOverflowMenu from './RoundOverflowMenu';

export default {
  inject: ['lang'],
  components: {
    DateTimezone,
    Icon,
    RoundOverflowMenu
  },
  computed: {
    ...mapState('judgingFastStart', ['rounds', 'configuredRound']),
    showOverflowMenu() {
      return this.rounds.filter(r => r.createdAt === null).length > 0;
    }
  },
  methods: {
    ...mapMutations('judgingFastStart', [
      'configureRound',
      'selectRound',
      'deleteRound'
    ]),
    onChange(event) {
      this.selectRound({
        id: event.target.value,
        selected: event.target.checked
      });
    },
    onDelete(round) {
      this.configureRound(null);
      this.deleteRound(round);
    },
    onEdit(round) {
      this.configureRound(round.id);
    }
  }
};
</script>

<style scoped>
.checkbox {
  text-align: left;
  margin-bottom: 0;
}

.checkbox input[type='checkbox'] {
  position: absolute;
}
</style>
